import 'rxjs/add/observable/empty';
import { Observable } from 'rxjs/Observable';
import type { Subscription } from 'rxjs/Subscription';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { NEW_GROUP_ID } from '../../../../common/constants';
import type { Group } from '../../../../common/types';
import updateGroupRest from '../../../update-group';
import type { ImmutableState, ContainerProps } from '../../types';
import type { ActionCallback } from '../types';
import { updateGroupMutator, addRevertFlagToErrorResponse } from '../utils';

const updateGroup =
	(groupId: number, newGroupName: string, callback: ActionCallback<Group>) =>
	(
		{ setState, getState }: StoreActionApi<ImmutableState>,
		{ projectId, activeStreams }: ContainerProps,
	): Subscription => {
		const state = getState();
		setState(updateGroupMutator({ id: groupId, name: newGroupName }, state));
		const optimisticState = getState();

		if (NEW_GROUP_ID === groupId) {
			return Observable.empty<never>().subscribe();
		}

		const subscription = updateGroupRest(projectId, groupId, newGroupName).subscribe(
			callback,
			(error) => {
				const canRevertState = optimisticState === getState();

				if (canRevertState) {
					setState(state);
				}
				callback(undefined, addRevertFlagToErrorResponse(error, canRevertState));
			},
		);

		activeStreams && activeStreams.add(subscription);

		return subscription;
	};

export default updateGroup;
